import React, { Component } from 'react'

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)

        this.state = { hasError: false }
    }

    static getDerivedStateFromError(error) {
        return { hasError: true }
    }

    componentDidCatch(error, info) {
        const { onErrorCaught } = this.props

        onErrorCaught && onErrorCaught(error, info)
    }

    render() {
        if (this.state.hasError) {
            return this.props.errorComponent
        }

        return this.props.children
    }
}

ErrorBoundary.defaultProps = {
    errorComponent: null,
}

export default ErrorBoundary
